import React, { useState, useEffect } from "react";
import "../../../../../../../styles/shared/pending-payment-list.css";

// components imports
import ApprovedTransectionTable from "../../../../../../../Components/BoltTable/BoltTable";
import InvoiceModal from "../../../../../../../Components/InvoiceModal/InvoiceModal";
import AddBalance from "../AddBalance/AddBalance";
import ImageModal from "../../Components/ImageModal/ImageModal";
import Tooltip from "../../../../../../../Components/Tooltip/Tooltip";
import noImage from "../../../../../../../assets/images/noImage.png";

// apis imports
import { fetchShipperPendingTransactions } from "../../../../../../../services/ShipperServices/Payments/payments.services";
import {
  convertTime,
  removeUnderscoresAndCapitalize,
} from "../../../../../../../helpers/helpers";

// library imports
import { FaArrowAltCircleUp } from "react-icons/fa";
import { MdOutlineStickyNote2 } from "react-icons/md";
import { useTranslation } from "react-i18next";

const PendingPaymentList = ({ setSnack }) => {
  const { t } = useTranslation("finances");
  const [transections, setTransections] = useState([]);

  const [invoiceModal, setInvoiceModal] = useState();
  const [addBalanceModal, setAddBalanceModal] = useState();
  const [imageModal, setImageModal] = useState();

  const getAllShippersTransections = async (page, perPage, filter) => {
    const response = await fetchShipperPendingTransactions(
      page,
      perPage,
      filter
    );
    if (!response.error) {
      setTransections(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("columns.paymentType"),
      field_name: "payment_type",
      render: (row, rowIndex, handleFieldChange) => (
        <>
          {row.payment_type
            ? removeUnderscoresAndCapitalize(row.payment_type)
            : "-"}
        </>
      ),
      width: "200px",
    },
    {
      id: 2,
      label: t("columns.transactionId"),
      field_name: "transaction_id",
      render: (row, rowIndex, handleFieldChange) => (
        <>{row?.transaction_id ?? "-"}</>
      ),
      width: "130px",
    },

    // {
    //   id: 3,
    //   label: "Bolt Tracking ID",
    //   field_name: "bolt_tracking_id",
    //   render: (row, rowIndex, handleFieldChange) => (
    //     <>{row.shipment?.tracking_id ?? "-"}</>
    //   ),
    //   width: "200px",
    // },
    {
      id: 4,
      label: t("columns.amount"),
      field_name: "amount",
      render: (row, rowIndex, handleFieldChange) => (
        <div
          style={{
            color:
              row?.transaction_type?.startsWith("credit") || true
                ? "teal"
                : "tomato",
            display: "flex",
          }}
        >
          <>
            {row.balance ?? "-"}
            <FaArrowAltCircleUp
              style={{ marginTop: "2px", marginLeft: "4px" }}
            />
          </>
        </div>
      ),
      width: "200px",
    },
    {
      id: 5,
      label: t("columns.status"),
      field_name: "status",
      render: (row, rowIndex, handleFieldChange) => (
        <>{row.status?.toUpperCase() ?? "-"}</>
      ),
      width: "200px",
    },
    {
      id: 6,
      label: t("columns.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("columns.reference"),
      field_name: "reference",
      render: (row, rowIndex, handleFieldChange) => (
        <>
          {row?.shipment_id ? (
            <div className="table_action__wrap">
              <Tooltip title={t("transactions.invoiceButton")}>
                <div
                  className="table_action__btn"
                  onClick={() => setInvoiceModal(row?.shipment_id)}
                >
                  <MdOutlineStickyNote2 size={10} />
                  {t("transactions.invoiceButton")}
                </div>
              </Tooltip>
            </div>
          ) : (
            <img
              src={row.file || noImage}
              style={{ cursor: "pointer" }}
              onClick={() => setImageModal(row.file || noImage)}
              onError={(e) => {
                e.target.src = noImage;
              }}
            />
          )}
        </>
      ),
      width: "200px",
    },
  ];

  return (
    <div>
      <div>
        <ImageModal open={imageModal} setOpen={setImageModal} />
        <InvoiceModal
          open={!!invoiceModal}
          data={invoiceModal}
          setOpen={setInvoiceModal}
          actions={false}
        />
        <AddBalance
          open={addBalanceModal}
          setOpen={setAddBalanceModal}
          setSnack={setSnack}
          getAllTransactions={() => getAllShippersTransections(1, 20, "")}
        />

        <ApprovedTransectionTable
          tableTitle={t("transactions.title")}
          tableId="pendingPaymentsTableforShipper"
          message={t("transactions.emptyPending")}
          searchPlaceHolder={t("transactions.search")}
          getAllData={getAllShippersTransections}
          data={transections}
          columns={columns}
        />
      </div>
    </div>
  );
};

export default PendingPaymentList;
